import './Header.css';

function Header() {
    return (
        <div className='header'>
            <h1 className="title">Guid.Best</h1>
            <span>
                <a className="tab-link" href="https://github.com/jtrinklein/guid.best">GitHub</a>
            </span>
        </div>
    );
}

export default Header;
